export const environment = {
  production: true,
  useEmulators: false,
  googleMapsApiKey: 'AIzaSyDY1jjKixRSucwbmeLUxs0qp2NqkJ40Fd4',
  firebaseVapidKey: '',
  firebase: {
    apiKey: 'AIzaSyCLOy9Vm6jxmX5i4XuFR2B8dILdw64-OpU',
    authDomain: 'omni-dev-7da3c.firebaseapp.com',
    projectId: 'omni-dev-7da3c',
    storageBucket: 'omni-dev-7da3c.firebasestorage.app',
    messagingSenderId: '604392902838',
    appId: '1:604392902838:web:dc2b0fbae342f2b48d1617',
    measurementId: 'G-7YZ70M4KF2',
  },
};
